import { render, staticRenderFns } from "./TranscriptSettings.vue?vue&type=template&id=6ec58544&scoped=true&"
import script from "./TranscriptSettings.vue?vue&type=script&lang=ts&"
export * from "./TranscriptSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec58544",
  null
  
)

export default component.exports